import { Paso } from './Paso';

export class PasoFuente extends Paso {
  constructor() {
    super(
      true,
      'Fuente',
      'La fuente es la encargada de alimentar al resto de los componentes y va a ser uno de los factores a tener en cuenta si querés armar una pc potente.',
      7,
      'power.png',
      'power.png',
      false,
      [],
      '',
    );
  }
}
